import { Route as ngRoute, Routes } from '@angular/router';

import { tenantFeaturesResolver } from '@app/shared/route-guards/tenant-features/tenant-features.resolver';

import { AuthenticationGuard } from './authentication/authentication.guard';
import { BaseLayoutComponent } from './layouts/base/base-layout.component';

/**
 * Provides helper methods to create routes.
 */
export class Route {
  /**
   * Creates routes using the shell component and authentication. The tenant's features are
   * loaded before the shell renders, so flagged entries and tabs do not pop in afterwards.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static withBaseLayoutAndAuthentication(routes: Routes): ngRoute {
    return {
      path: '',
      component: BaseLayoutComponent,
      children: routes,
      canActivate: [AuthenticationGuard],
      resolve: { tenantFeatures: tenantFeaturesResolver },
    };
  }
}
